import React from "react";
import { Table } from "@abb/abb-common-ux-react";
import { useTranslation } from "react-i18next";

export const WildcardPopup = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Table
      sizeClass={"medium"}
      solidBackground={false}
      borderType={"none"}
      zebra={true}
      style={{ width: "700px" }}
    >
      <thead>
        <tr>
          <th style={{ width: "100px" }}>{t("Symbol")}</th>
          <th>{t("Description")}</th>
          <th>{t("Example")}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{t("% or *")}</td>
          <td>{t("zero or more characters")}</td>
          <td>{t("bl% finds bl, black, blue, and blob")}</td>
        </tr>
        <tr>
          <td>{t("_")}</td>
          <td>{t("a single character")}</td>
          <td>{t("h_t finds hot, hat, and hit")}</td>
        </tr>
        <tr>
          <td>{t("[ ]")}</td>
          <td>{t("any single character within the brackets")}</td>
          <td>{t("h[oa]t finds hot and hat, but not hit")}</td>
        </tr>
        <tr>
          <td>{t("^")}</td>
          <td>{t("any character not in the brackets")}</td>
          <td>{t("h[^oa]t finds hit, but not hot and hat")}</td>
        </tr>
      </tbody>
    </Table>
  );
};
